export default __webpack_public_path__ + "static/media/tb-features.c60a624c.png";